import { CurrencyPipe, DatePipe } from '@angular/common';
import localePtBr from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { EmpresaModel } from '../models/empresaModel';
import { ProdutoModel, DetalheProdutoModel } from '../models/produtoModel';
import { GrupoModel } from '../models/grupoModel';
import { AcompanhamentoModel } from '../models/acompanhamentoModel';

export class Global {
    constructor() { }

    public static IdentificacaoEmpresa: string = '';
    public static UrlChamadora: string = '';

    //Produção
    public static UrlServico: string = 'https://bitdelivery-api.azurewebsites.net/api/';

    //Servidor Local - HLG
    //public static UrlServico: string = 'http://192.168.1.114:4000/api/';

    //Servidor Local - DEV
    //public static UrlServico: string = 'http://192.168.1.114:4500/api/';
    
    //Máquina local
    //public static UrlServico: string = 'http://localhost:51747/api/';
    
    public static Versao: string = '1.1.0.2';
    public static Ambiente: string = 'P';
    public static EhProducao: boolean = Global.Ambiente == 'P';

    /* Nomes de rotas */
    public static RotaTabs: string = 'tabs';
    public static RotaSplash: string = 'splash';
    public static RotaDetalheProduto: string = 'detalheProduto';
    public static RotaCarrinho: string = 'tabs/Carrinho';
    public static RotaAbertura: string = 'tabs/cardapio';
    public static RotaPaginaAbertura: string = 'cardapio'; 
    public static CardapioVirtual: string = 'cardapioVirtual';
   
    public static Empresa: EmpresaModel;
    public static GrupoProduto: GrupoModel;
    public static Produto: ProdutoModel;
    public static ObservacaoPedido: string;
    public static Acompanhamento: AcompanhamentoModel;
    public static TempoSetFocus: number = 750;
    public static QuantidadeItensCarrinho: number = 0;
    public static RolagemTopo: boolean = true;
    public static PaginaAtualPesquisaProduto: number = 1;
    public static CarregamentoCompleto: boolean = false;
    public static PaginaAtualPesquisaImagemProduto: number = 1;
    public static CarregamentoCompletoImagem: boolean = false;

    //SelfOrdering
    public static CodigoMesaPedido: number = 0;
    public static CodigoMesa: string = '';
    public static CodigoMesaCripto: string = '';
    public static PermiteCriarPedido: boolean = false;
    public static EhDispositivoVinculado: boolean = false;

    public static PadLeft(conteudo: string, quantidade: number, padding: string) {
        let n = conteudo.length;

        let join = '';
        if (quantidade > n) {
            for (let i = 0; i < (quantidade - n); i++) {
                join += padding;
            }
        }

        return join + conteudo;
    }

    public static async Sleep(tempo: number, acao: any) {
        let ex = (async () => {
            setTimeout(() => {
                acao();
            }, tempo);
        });

        await ex();
    }

    public static isNullOrEmpty(conteudo: any) {
        return (conteudo != null && conteudo != 'undefined' && conteudo.trim() != '');
    }

    public static FormatarMoeda(valor: number): string{
        registerLocaleData(localePtBr);
        let currencyPipe: CurrencyPipe = new CurrencyPipe("pt-BR");

        return currencyPipe.transform(valor, "BRL", "symbol", '0.2-2');
    }

    public static FormatarDataHora(data: Date): string{
        registerLocaleData(localePtBr);
        let datePipe: DatePipe = new DatePipe("pt-BR");

        return datePipe.transform(data, "dd/MM/yyyy HH:mm");
    }
}
